import React from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {Button} from 'react-bootstrap'
import {FieldGroup} from '../helpers/form'
import {withRouter} from 'react-router-dom'
import {loginUser, updateIsLoggedIn} from '../actions'
import * as ActionTypes from '../actionTypes'
import queryString from 'query-string'
import api from '../api'

@withRouter
@connect((state) => {
  return {
    isLoggedIn: state.app.isLoggedIn,
  }
})
@api
export default class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: {
        username: '',
        password: '',
      },
      submitted: false,
      is_logging_in_with_api: false,
      error_response: '',
    }

    if (this.props.isLoggedIn) {
      this.props.history.push('/futures')
    }

    const query = queryString.parse(this.props.location.search)
    if (query.username) {
      this.state.user.username = query.username
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    const {id, value} = event.target
    const {user} = this.state
    this.setState({
      user: {
        ...user,
        [id]: value,
      },
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState({submitted: true, error_response: ''})
    const {user} = this.state
    const {dispatch, apiInstance, history} = this.props

    if (user.username && user.password) {
      this.setState({is_logging_in_with_api: true})
      var config = {
        auth: {
          username: user.username,
          password: user.password,
        },
      }
      apiInstance
        .get('login', config)
        .then((response) => {
          this.setState({is_logging_in_with_api: false})
          if (response) {
            if (response.status === ActionTypes.API_OK) {
              dispatch(updateIsLoggedIn(true))
              dispatch(loginUser(response.data))

              window.alert('Successfully Logged In!')
              history.push('/futures')
            } else if (response.status === ActionTypes.API_FAIL) {
              this.setState({error_response: response.msg})
              return
            }
          } else {
            //Failed to receive response from server
            this.setState({
              error_response:
                'Error: No Response from server, please try again.',
            })
            return
          }
        })
        .catch((err) => {
          this.setState({is_logging_in_with_api: false, error_response: err})
        })
    }
  }

  render() {
    const {user, submitted, is_logging_in_with_api, error_response} = this.state

    return (
      <div className="col-md-12">
        <form className="modal-dialog" name="form" onSubmit={this.handleSubmit}>
          <div className="col-md-12">
            <FieldGroup
              id="username"
              type="text"
              label="Username"
              placeholder="Enter your Username "
              value={user.username}
              onChange={this.handleChange}
            />
            {submitted &&
              user.username.length === 0 && (
                <div className="help-block">Please enter your username</div>
              )}
          </div>
          <div className="col-md-12">
            <FieldGroup
              id="password"
              type="password"
              label="Password"
              placeholder="Enter your password"
              onChange={this.handleChange}
            />
            {submitted &&
              user.password.length === 0 && (
                <div className="help-block">Please enter your password</div>
              )}
          </div>
          {error_response.length > 0 && (
            <div className="col-md-12 error-block">{error_response}</div>
          )}
          <div className="col-md-12">
            <Button
              className="btn btn-success"
              type="submit"
              disabled={is_logging_in_with_api}
            >
              {is_logging_in_with_api ? (
                <div>
                  <i className="fa fa-spinner fa-spin" /> Logging in
                </div>
              ) : (
                'Login'
              )}
            </Button>
            <Link to="/register" className="btn btn-link">
              Register
            </Link>
          </div>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/login.js